"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SelectInputWrapper = _styledComponents.default.div`
  select {
    font-size: 12px;
    padding-right: 28px;
    text-overflow: ellipsis;
    ${_r10SourceLibrary.Mixins.respondTo.md(`
  font-size: 20px;
 `)}
  }
`;
const SelectInput = _ref => {
  let {
    productId,
    selectOptions,
    onChangeHandle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(SelectInputWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SelectInputWithMenuWithLabel, {
    fieldWrapper: {
      showLabel: false
    },
    selectInputWithMenu: {
      id: 'product-selector',
      name: 'product-selector',
      value: productId,
      onChange: value => {
        onChangeHandle(productId, value);
      },
      options: selectOptions,
      ariaLabel: 'noLabel'
    }
  }));
};
var _default = SelectInput;
exports.default = _default;